import { Component, OnInit, NgZone } from '@angular/core';
declare var UnityLoader: any;

@Component({
  selector: 'app-unity',
  templateUrl: './unity.component.html',
  styleUrls: ['./unity.component.css']
})
export class UnityComponent implements OnInit {
  containerWidth = 600;
  containerHeight = 800;
  startVehicle = 0;
  progress = 0;
  gameInstance;
  isLoading = true;
  debug = false;
  constructor(private _ngZone: NgZone) {
    window['angularUnityComponent'] = {
      zone: this._ngZone, 
      onComplete: (vehicle:number) => this.onUnityComplete(vehicle), 
      component: this
    };
    this.isLoading = true;
    this.containerWidth = window.innerWidth;
    let _progress = 0;
    if(!this.debug){
      this.gameInstance = UnityLoader.instantiate("gameContainer", "assets/Build/web.json", {onProgress: function(gameInstance, progress){
        _progress = progress;
      }});
      setInterval(()=>{this.progress = _progress},100);
    } else {
      this.isLoading = false;
    }
    
  }
  ngOnInit() {
    
  }
  onUnityComplete(vehicle: number) {
    this.startVehicle = vehicle;
    this.onResize(null);
    this.isLoading = false;
  }
  onUnityEvent(target){
    this.gameInstance.SendMessage("MainController", "On"+target);
  }
  onStopVideo(){
    this.gameInstance.SendMessage("VideoController", "StopVideo");
  }
  onUnityPrevVehicle(type: string){
    this.gameInstance.SendMessage("6 Spot Fahrzeuge", "OnPrevVehicle", type);
  }
  onUnityNextVehicle(type: string){
    this.gameInstance.SendMessage("6 Spot Fahrzeuge", "OnNextVehicle", type);
  }
  onUnitySetVehicle(type: string, nr: number){
    console.log(type+","+nr.toString());
    this.gameInstance.SendMessage("6 Spot Fahrzeuge", "OnSetVehicle", type+","+nr.toString());
  }
  onUnityChangeLanguage(lang: string){
    this.gameInstance.SendMessage("MainController", "OnChangeLanguage", lang);
  }
  onResize(event) {
    this.containerWidth = window.innerWidth;
    this.containerHeight = window.innerHeight-64;
    document.getElementsByTagName("canvas")[0].setAttribute("width", this.containerWidth.toString());
    document.getElementsByTagName("canvas")[0].setAttribute("height", this.containerHeight.toString());
  }

}



// WEBPACK FOOTER //
// ./src/app/unity/unity.component.ts